var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import merge from 'lodash.merge';
import { useMemo } from 'react';
import { FactoryComponent } from '../../../factory';
import withDesign from '../../../hocs/withDesign';
import useWatch from '../../../hooks/useWatch';
import { mapValues, prepareAutoFormatConfig } from '../../../utils/parsers';
import { prepareAndFormat } from '../../../utils/strings';
function prepareProps(_a) {
    var _b;
    var _c = _a.autoFormats, autoFormats = _c === void 0 ? {} : _c, _d = _a.autoPick, autoPick = _d === void 0 ? '' : _d, pick = _a.pick, mapper = _a.mapper, _e = _a.format, _f = _e === void 0 ? {} : _e, text = _f.text, _g = _f.as, formattedValueAs = _g === void 0 ? 'children' : _g, format = __rest(_f, ["text", "as"]), converter = _a.converter, values = _a.values, component = _a.component, _h = _a.partials, partials = _h === void 0 ? [] : _h, rest = __rest(_a, ["autoFormats", "autoPick", "pick", "mapper", "format", "converter", "values", "component", "partials"]);
    var _j = prepareAutoFormatConfig({
        autoFormats: autoFormats,
        autoPick: autoPick,
        pick: pick,
        values: values,
    }), autoPartials = _j.partials, autoFormat = __rest(_j, ["partials"]);
    var partialsFormattedPropsAndValues = (autoPartials || partials).reduce(function (accValues, partialFormatContent) {
        var partialFormatDetails = partialFormatContent.format, partialPick = partialFormatContent.pick, restOfPartialFormat = __rest(partialFormatContent, ["format", "pick"]);
        var partialAs = partialFormatDetails.as, restOfPartialFormatDetails = __rest(partialFormatDetails, ["as"]);
        var formattedProps = prepareProps(__assign(__assign({ pick: partialPick === 'useParentPick' ? pick : partialPick, format: __assign({ as: partialAs === 'useParentPick' ? pick : partialAs }, restOfPartialFormatDetails) }, restOfPartialFormat), { values: accValues }));
        return __assign(__assign({}, accValues), formattedProps);
    }, values);
    var mappedValues = mapValues({
        autoFormats: autoFormats,
        autoPick: autoPick,
        autoFormat: autoFormat,
        values: partialsFormattedPropsAndValues,
        mapper: mapper,
        pick: pick,
        converter: converter,
    });
    var formattedValue = prepareAndFormat(__assign({ mappedValues: mappedValues, autoFormat: autoFormat, format: format, text: text }, rest));
    var formattedProp = (_b = {}, _b[formattedValueAs] = formattedValue, _b);
    var mappedValuesAsProps = component && formattedValueAs === 'children' && mappedValues;
    var formattedValues = merge({}, formattedProp, mappedValuesAsProps);
    return merge({}, mappedValuesAsProps, formattedProp, {
        values: formattedValues,
    });
}
var FormatterWithWatch = function (_a) {
    var watch = _a.watch, propValues = _a.values, rest = __rest(_a, ["watch", "values"]);
    var watchedValues = useWatch(watch);
    var values = useMemo(function () { return merge({}, watchedValues, propValues); }, [propValues, watchedValues]);
    return _jsx(FormatterPure, __assign({ values: values }, rest));
};
var FormatterPure = function (_a) {
    var design = _a.design, 
    // format and mapValues props
    _b = _a.autoFormats, 
    // format and mapValues props
    autoFormats = _b === void 0 ? {} : _b, _c = _a.autoPick, autoPick = _c === void 0 ? '' : _c, preset = _a.preset, pick = _a.pick, text = _a.text, _d = _a.values, values = _d === void 0 ? {} : _d, mapper = _a.mapper, format = _a.format, _e = _a.partials, partials = _e === void 0 ? [] : _e, converter = _a.converter, formatter = _a.formatter, 
    // FactoryComponent props
    as = _a.as, isLoading = _a.isLoading, skeleton = _a.skeleton, 
    // Component to be rendered
    component = _a.component, props = __rest(_a, ["design", "autoFormats", "autoPick", "preset", "pick", "text", "values", "mapper", "format", "partials", "converter", "formatter", "as", "isLoading", "skeleton", "component"]);
    var presetValues = mapValues(__assign({ values: values }, preset));
    var preparedProps = useMemo(function () {
        return prepareProps(__assign({ autoFormats: autoFormats, autoPick: autoPick, pick: pick, mapper: mapper, format: __assign({ text: text, formatter: formatter }, format), converter: converter, values: __assign(__assign({}, values), presetValues), component: component, partials: partials }, props));
    }, [values]);
    return (_jsx(FactoryComponent, __assign({ component: component, "data-design": design, isLoading: isLoading, skeleton: skeleton, as: as }, props, preparedProps)));
};
export var FormatterComponent = function (_a) {
    var watch = _a.watch, rest = __rest(_a, ["watch"]);
    if (watch) {
        return _jsx(FormatterWithWatch, __assign({ watch: watch }, rest));
    }
    return _jsx(FormatterPure, __assign({}, rest));
};
export var Formatter = withDesign(FormatterComponent);
Formatter.displayName = 'Formatter';
